import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';

function ErrorPage({
  statusCode,
  name,
  description,
}: {
  statusCode: number;
  name: string;
  description: string;
}) {
  return (
    <div className={layoutStyles.pageContainer}>
      <div className={`${utilsStyles.mtMediumNoMediaDiff} ${utilsStyles.centeredVertical}`}>
        <PageHeader text={`${statusCode}`} size='medium' />
        <div className={utilsStyles.mtSmall}>
          <p className={`${utilsStyles.textXXLargeNoMediaDiff} ${utilsStyles.textBold} ${utilsStyles.textCenter}`}>
            {name}
          </p>
          <p className={`${utilsStyles.mtXXSmallNoMediaDiff} ${utilsStyles.textCenter}`}>{description}</p>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
